"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ListItem_1 = __importDefault(require("../ListItem"));
var ListItemText_1 = __importDefault(require("../ListItemText"));
var react_1 = __importStar(require("react"));
var styles_1 = require("./styles");
var react_i18next_1 = require("react-i18next");
var useLayoutLinks_1 = require("./hooks/useLayoutLinks");
var Avatar_1 = __importDefault(require("../Avatar"));
var MobileMultipleBanks_1 = __importDefault(require("./MobileMultipleBanks"));
var Layout_1 = __importDefault(require("../context/Layout"));
var MobileListItems = function (_a) {
    var _b;
    var links = _a.links, handleNavigation = _a.handleNavigation, avatarSrc = _a.avatarSrc, fullName = _a.fullName, multipleBanksObj = _a.multipleBanksObj, identifier = _a.identifier;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _c = __read((0, react_1.useContext)(Layout_1.default), 3), __ = _c[0], layoutQuery = _c[1], _ = _c[2];
    var layout = layoutQuery === null || layoutQuery === void 0 ? void 0 : layoutQuery.data;
    var hasRedeemPermission = (_b = layout === null || layout === void 0 ? void 0 : layout.hasRedeemAwardsPermission) === null || _b === void 0 ? void 0 : _b.hasRedeemAwardsPermission;
    var newTabProps = {
        target: '_blank',
        rel: 'noopener noreferrer',
    };
    var getMultipleBanks = function () {
        if (multipleBanksObj && hasRedeemPermission) {
            if (multipleBanksObj.hasMultipleBank) {
                return (react_1.default.createElement(MobileMultipleBanks_1.default, { banks: multipleBanksObj.multipleBanks, codes: multipleBanksObj.accessCodes, handleNavigation: handleNavigation, identifier: identifier }));
            }
            else {
                return (react_1.default.createElement(ListItem_1.default, { "data-testid": "store-link", className: "fs-unmask", component: "a", key: "store", sx: styles_1.ListItemStyle, href: multipleBanksObj === null || multipleBanksObj === void 0 ? void 0 : multipleBanksObj.bankUrl, onClick: handleNavigation(multipleBanksObj.bankUrl) },
                    react_1.default.createElement(ListItemText_1.default, { "aria-label": "Store. Shop Now" }, t('prism-header:store'))));
            }
        }
        else {
            return null;
        }
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, links.map(function (_a) {
        var id = _a.id, translationString = _a.translationString, url = _a.url;
        return (react_1.default.createElement(react_1.Fragment, { key: identifier + id },
            react_1.default.createElement(ListItem_1.default, __assign({ "data-testid": "".concat(translationString, "-link"), key: identifier + id + '-link', className: "fs-unmask", sx: styles_1.ListItemStyle, component: "a", onClick: handleNavigation(url), href: url }, ((id === useLayoutLinks_1.SecondaryLinks.Admin ||
                id === useLayoutLinks_1.PrimaryLinks.Wellbeing) &&
                newTabProps)), id === useLayoutLinks_1.MenuLinks.Profile ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(Avatar_1.default, { src: avatarSrc, size: "sm" }),
                react_1.default.createElement(styles_1.MenuAvatarText, null, fullName))) : (react_1.default.createElement(ListItemText_1.default, null, t("prism-header:".concat(translationString))))),
            id === useLayoutLinks_1.MenuLinks.Profile && getMultipleBanks()));
    })));
};
exports.default = MobileListItems;
//# sourceMappingURL=MobileListItems.js.map